export default "__VITE_ASSET__a1b16a59__"